module.exports = __webpack_public_path__ + "static/media/7.31409e67.JPG";